export default __webpack_public_path__ + "static/media/er.bbb6f885.svg";